const menuIcons: Array<[RegExp, string]> = [
  [/\bdashboard\b/, 'bi-grid'],
  [/\bcustomers?\b/, 'bi-people'],
  [/\buser management\b/, 'bi-people'],
  [/\brestaurants?\b/, 'bi-shop'],
  [/\b(delivery|deliveries|drivers?)\b/, 'bi-truck'],
  [/\b(finance|financial|payments?|transactions?)\b/, 'bi-bank'],
  [/\borders?\b/, 'bi-cart'],
  [/\bproducts?\b/, 'bi-box-seam'],
  [/\brecipes?\b/, 'bi-journal'],
  [/\binventory\b/, 'bi-boxes'],
  [/\b(promotions?|offers?|coupons?|discounts?)\b/, 'bi-tag'],
  [/\bmaster\b/, 'bi-grid'],
  [/\breports?\b/, 'bi-bar-chart'],
  [/\bsettings?\b/, 'bi-gear'],
  [/\bcms\b/, 'bi-file-earmark-text'],
  [/\bnotifications?\b/, 'bi-bell'],
  [/\b(enquiries|enquiry|inquiries|inquiry)\b/, 'bi-chat'],
  [/\bsupport\b/, 'bi-headset'],
  [/\b(logout|log out|sign out)\b/, 'bi-box-arrow-right'],
]

export function getMenuIcon(to: string, title: string, fontIcon?: string): string {
  for (const value of [title, to]) {
    const normalized = value.replace(/([a-z])([A-Z])/g, '$1 $2').toLowerCase().replace(/[^a-z0-9]+/g, ' ')
    const match = menuIcons.find(([pattern]) => pattern.test(normalized))
    if (match) return match[1]
  }
  return fontIcon?.split(/\s+/).find((name) => /^bi-[a-z0-9-]+$/.test(name)) || 'bi-circle'
}